import {
  FactoryFn,
  ModifyDomainFn,
  ScaleObject,
} from '@devexpress/dx-react-chart';
import { scaleLinear, scalePow, scaleTime } from 'd3-scale';
import { formatDate } from 'globals/utils';

// ===================================================
// scaleFactory

export const scaleFactory = (
  min: number,
  max: number
): FactoryFn => (): ScaleObject => {
  const customScale = scaleLinear();
  const ticksArray = scalePow([min, max], [min, max]).ticks(5);
  customScale.ticks = (): number[] => ticksArray;
  return customScale;
};

export const scaleDateFactory = (): FactoryFn => (): ScaleObject => {
  return scaleTime();
};

// ===================================================
// tickFormatterForArgumentAxis

type TickFormatter = (tick: string) => string;

export const tickFormatterForArgumentAxis = (): TickFormatter => (
  tick: string
): string => {
  const tickNumber = Number(tick);
  return formatDate(tickNumber);
};

// ===================================================
// domainModifier

export const domainModifier = (
  min: number,
  max: number
): ModifyDomainFn => (): number[] => [
  min - 0.05 * Math.abs(max - min),
  max + 0.05 * Math.abs(max - min),
];

// ===================================================
// getMinMaxValue

export interface GetMinMaxValue {
  min: number;
  max: number;
}

export interface FsLineToggleChartSingleRowProps {
  [prop: string]: number;
  idx: number;
  x: number;
  hidden: number;
}

export const getMinMaxValue = (
  chartData: FsLineToggleChartSingleRowProps[]
): GetMinMaxValue => {
  const chartDataMinMaxRowValues = chartData.map((dataRow) => {
    const chartDataRowValues = Object.entries(dataRow)
      .filter(([key]) => key.includes('tab'))
      .map(([, value]) => value);
    const minRowValue = Math.min(...chartDataRowValues);
    const maxRowValue = Math.max(...chartDataRowValues);
    return { min: minRowValue, max: maxRowValue };
  });
  const minChartDataValue = Math.min(
    ...chartDataMinMaxRowValues.map(({ min }) => min)
  );
  const maxChartDataValue = Math.max(
    ...chartDataMinMaxRowValues.map(({ max }) => max)
  );

  return { min: minChartDataValue, max: maxChartDataValue };
};
